import {LongtermBetslip} from "../../../features/betslip/longterm.service";
import React from "react";

/**
 * Kupon panelindeki uzun vadeli seçim satırı.
 *
 * Aynı işaretleme `EkuriBetSlip` (masaüstü kenar çubuğu) ve `Betslip` (/bilet-onay tam
 * sayfası) içinde BİREBİR iki kez duruyordu; tek bileşene indirildi. Betslip'i yüzey
 * bazından tür bazına taşımanın ilk adımı: uzun vadelinin nasıl göründüğü artık tek yerde.
 *
 * Silme düğmesi `clearTjkBetSlip()` çağırıyordu; uzun vadeli seçim kendi servisine taşındıktan
 * sonra o fonksiyon bu seçimi GÖREMİYOR ve düğme sessizce hiçbir şey yapmıyordu. Artık
 * doğru servisi çağırıyor.
 */
export function LongtermSelectionRow({selection}: {selection: any}) {
    return (
        <div className={"d-flex justify-content-between p-1 border-bottom"}>
            <div className={"d-flex flex-column w-100"}>
                <span className={"text-xsmall fw-bold"}>{selection.hippodrome.hippodrome}</span>
                <div className={"d-flex justify-content-between pe-1"}>
                    <span className="text-xxsmall horse-name">{selection.horse.description}</span>
                    <span className="text-xsmall fw-bold">{Number(selection.horse.win_odds).toFixed(2)}</span>
                </div>
            </div>
            <button className="button xs tertiary outlined delete" onClick={() => {
                LongtermBetslip.clear();
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                     viewBox="0 0 17 16" fill="none">
                    <path
                        d="M3.83329 5.33325V11.9999C3.83329 13.4727 5.0272 14.6666 6.49996 14.6666H10.5C11.9727 14.6666 13.1666 13.4727 13.1666 11.9999V5.33325M9.83329 7.33325V11.3333M7.16663 7.33325L7.16663 11.3333M11.1666 3.33325L10.2291 1.92698C9.98183 1.55605 9.56552 1.33325 9.11971 1.33325H7.88021C7.4344 1.33325 7.01809 1.55605 6.7708 1.92698L5.83329 3.33325M11.1666 3.33325H5.83329M11.1666 3.33325H14.5M5.83329 3.33325H2.49996"
                        stroke="var(--primary-color)" strokeLinecap="round"
                        strokeLinejoin="round"></path>
                </svg>
            </button>
        </div>
    );
}
